(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-products"] && !Shopify.designMode) return;
  try {
    (() => {
  let frame;
  let mutations;
  const observed = new Set();
  const schedule = () => {
    if (!frame) frame = requestAnimationFrame(update);
  };
  const resize = new ResizeObserver(schedule);
  function update() {
    frame = undefined;
    // Measuring a one-time row must not queue another mutation update itself.
    mutations?.disconnect();
    for (const node of observed) {
      if (!node.isConnected) {
        resize.unobserve(node);
        observed.delete(node);
      }
    }
    for (const row of document.querySelectorAll('.cart-items__table-row--aligned-details')) {
      const pills = row.querySelector('.cart-items__pills');
      const badge = row.querySelector('.cart-pill--discount') || row.querySelector('.cart-pill--pack');
      const controls = row.querySelector('.cart-items__quantity-controls');
      if (!badge || !controls) continue;
      for (const node of [row, pills]) {
        if (node && !observed.has(node)) {
          observed.add(node);
          resize.observe(node);
        }
      }
      if (!row.getClientRects().length || badge.getBoundingClientRect().width === 0) continue;
      let edge = badge.getBoundingClientRect().right;
      if (!row.querySelector('.cart-pill--discount') && Number(row.dataset.counterDiscount) > 0) {
        const probe = document.createElement('span');
        probe.className = 'cart-pill cart-pill--discount';
        probe.textContent = `−${row.dataset.counterDiscount}%`;
        probe.setAttribute('aria-hidden', 'true');
        probe.style.cssText = 'position:absolute;visibility:hidden;pointer-events:none';
        pills.append(probe);
        const discountWidth = probe.getBoundingClientRect().width;
        probe.remove();
        const gap = parseFloat(getComputedStyle(pills).columnGap) || 0;
        const pack = badge.getBoundingClientRect();
        const combined = pack.width + gap + discountWidth;
        const meta = row.querySelector('.cart-items__meta');
        const pricing = row.querySelector('.cart-items__row-pricing');
        const priceProbe = document.createElement('span');
        priceProbe.className = 'cart-items__row-current';
        priceProbe.textContent = row.dataset.counterPrice;
        priceProbe.style.cssText = 'position:absolute;visibility:hidden;pointer-events:none';
        pricing.append(priceProbe);
        const priceWidth = Math.max(priceProbe.getBoundingClientRect().width, row.querySelector('.cart-items__row-compare')?.getBoundingClientRect().width || 0);
        priceProbe.remove();
        const available = meta.getBoundingClientRect().width - priceWidth - (parseFloat(getComputedStyle(meta).columnGap) || 0);
        const wraps = combined > available + 0.5;
        edge = pack.left + (wraps ? discountWidth : combined);
      }
      const width = edge - controls.getBoundingClientRect().left;
      const previous = parseFloat(row.style.getPropertyValue('--cart-counter-width')) || 0;
      if (width > 0 && Math.abs(previous - width) > 0.01) {
        row.style.setProperty('--cart-counter-width', `${width}px`);
      }
    }
    mutations?.observe(document.body, { childList: true, subtree: true });
  }
  const start = () => {
    mutations = new MutationObserver(schedule);
    mutations.observe(document.body, { childList: true, subtree: true });
    window.addEventListener('resize', schedule, { passive: true });
    document.fonts.ready.then(schedule);
    schedule();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
  } catch(e) { console.error(e); }
})();

})();
